import React, { useState } from 'react';
import { View, FlatList } from 'react-native';
import MyAppText from '../components/MyAppText';
import { translate } from '../services/translate';
import { NavigationProp, useNavigation, useNavigationState } from '@react-navigation/native';
import UserInformationModal from '../components/UserInformationModal';
import releases from '../services/version.json';
import { RootStackParamList } from '../typings/Params';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Container from '../components/Container';
import Card from '../components/Card';
import Header from '../components/Header';

interface Release {
    version: string;
    releaseDate?: string;
    content: string[];
    fixes?: string[];
}

export default function ChangeLogs() {
    const { styles } = useStyles(styleSheet);

    const index = useNavigationState(state => state);
    const [showDropDown, setShowDropDown] = useState<boolean>(false);

    const navigation = useNavigation<NavigationProp<RootStackParamList>>();

    function goBack() {
        if (index.routes.length > 1) {
            return navigation.goBack();
        }
        window.location.href = '/menu';
    }

    function renderItem({ item }: { item: Release; }) {
        return (
            <View style={{ rowGap: 15 }}>
                <View style={{ rowGap: 5 }}>
                    <MyAppText style={styles.versionText}>{translate('version')}: {item.version}</MyAppText>
                    {item.releaseDate && <MyAppText style={styles.releaseDateText}>{translate('update')}: {item.releaseDate}</MyAppText>}
                </View>
                <MyAppText style={styles.versionSubText}>{translate('newFeatures')}:</MyAppText>
                <View style={styles.contentView}>
                    {item.content.map((change, index) => (
                        <MyAppText key={index}>{`\u2022 ${change}`}</MyAppText>
                    ))}
                </View>
                {(item.fixes || []).length > 0 && <MyAppText style={styles.versionSubText}>{translate('fixes')}:</MyAppText>}
                <View style={styles.contentView}>
                    {(item.fixes || []).map((change, index) => (
                        <MyAppText key={index}>{`\u2022 ${change}`}</MyAppText>
                    ))}
                </View>
            </View>
        );
    }

    return (
        <Container>
            <Header
                title={translate('changeLogs')}
                goBackAction={goBack}
            />
            <Card>
                <FlatList data={releases} contentContainerStyle={{ rowGap: 30 }} renderItem={renderItem} />
            </Card>
            <UserInformationModal
                showDropDown={showDropDown}
                setShowDropDown={setShowDropDown}
                navigation={navigation}
            />
        </Container>
    );
}

const styleSheet = createStyleSheet(() => ({
    versionText: {
        fontWeight: 'bold',
        fontSize: 24
    },
    releaseDateText: {
        fontSize: 12,
        fontStyle: 'italic'
    },
    versionSubText: {
        fontWeight: 'bold',
        fontSize: 14
    },
    contentView: {
        rowGap: 5,
        paddingLeft: 15,
    },
}));
